export let hres31xColumns = () => {
  let tab13PopupColumns = [{
    key: 'grade',
    name: '',
    labelCodapp: 'STD_SKILSC',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 60px;'
  }, {
    key: 'desc_grade',
    name: '',
    labelCodapp: 'STD_SKILSC',
    labelIndex: '40',
    class: 'align-left',
    style: 'min-width: 100px;'
  }, {
    key: 'score',
    name: '',
    labelCodapp: 'STD_SKILSC',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 60px;'
  }]

  return {
    en: {
      detailTab13Popup: tab13PopupColumns
    },
    th: {
      detailTab13Popup: tab13PopupColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres31x.js